import { HealthCheckInResult } from './task.interface';

export const HEALTH_CHECK_IN_RESULT_CHIP_CLASS: Record<HealthCheckInResult, string> = {
  Improved: 'bg-success-50 text-success-600',
  Unchanged: 'bg-warning-50 text-warning-600',
  Worsened: 'bg-error-50 text-error-600',
};
